/**
 * Client categories in the journal (boona clients README §3.6): the appointment payload's
 * client_tags carry the salon's category id as `cid` (imported items may still use `id`); the
 * picker's choice goes back with the visit's Save as `client.category_ids`.
 */
export type Category = { id: number; title: string; color: string }

/** The payload's client_tags as the picker's categories (by the salon's category id). */
export function fromPayload(tags: any[] | null | undefined): Category[] {
  const out: Category[] = []
  const seen = new Set<number>()
  for (const x of tags || []) {
    const id = Number(x?.cid ?? x?.id)
    if (!x?.title || !Number.isFinite(id) || id <= 0 || seen.has(id)) continue
    seen.add(id)
    out.push({ id, title: String(x.title), color: String(x.color || "") })
  }
  return out
}

/** The ids after ticking `id` on or off. */
export function toggledIds(selected: number[], id: number): number[] {
  return selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]
}
